import React from "react";
import Box from "@mui/material/Box";
import { Body, BodyContent } from "@thrivetribe/mvf.ui.organisms.body";
import { ReactComponent as ErrorPageImage } from "assets/img/errorPageImage.svg";
import "./Errors.scss";
import { Helmet } from "react-helmet-async";

/**
 * A base component to generate/compose various error pages such as 404,500 etc.,
 * @param {string} pageTitle -  Page title
 * @param {string} pageHeading -  Page heading
 * @param {string} pageCopy -  Page copy/description
 * @param {React.ReactNode} children - Render CTA button(s)
 * @param {React.ReactNode} errorImage - Render main error image. Set as optional and If its not provided then a generic ErrorPageImage would be displayed.
 */
export interface ErrorMessageContentProps {
  pageTitle?: string;
  pageHeading: string;
  pageCopy: string;
  children?: React.ReactNode;
  errorImage?: React.ReactNode;
}

const ErrorMessage = (props: ErrorMessageContentProps) => {
  let { pageTitle, pageHeading, pageCopy, errorImage, children } = props;
  return (
    <Body>
      {pageTitle && (
        <Helmet>
          <title>{pageTitle}</title>
        </Helmet>
      )}
      <BodyContent>
        <Box className="error-page__container">
          <h1 className="error-page__heading">{pageHeading}</h1>
          <p className="error-page__copy">{pageCopy}</p>
          <div className="error-page__button-container"> {children} </div>
          {errorImage ? errorImage : <ErrorPageImage className="error-page__image" />}
        </Box>
      </BodyContent>
    </Body>
  );
};

export default ErrorMessage;
